import { gql } from '@apollo/client';

export const CASE_ID_CONFIGURATION_FIELDS = gql`
  fragment CaseIdConfigurationFields on CaseIdConfiguration {
    id
    mode
    description
    preset
    pattern
    separator
    householdIdEnabled
    householdCodeEnabled
    memberStyle
    memberMax
    segments {
      id
      key
      prefix
      padding
      startNumber
      excludedRanges
    }
  }
`;

// The organisation's saved Case ID configuration. Null until an administrator has saved one, in
// which case the generator falls back to the legacy behaviour.
export const GET_CASE_ID_CONFIGURATION = gql`
  query getCaseIdConfiguration {
    configuration: getCaseIdConfiguration {
      ...CaseIdConfigurationFields
    }
  }
  ${CASE_ID_CONFIGURATION_FIELDS}
`;

// Which identifier fields the organisation uses. Readable by any signed-in user, unlike the full
// configuration, because every case screen needs it to know what to render.
export const GET_CASE_ID_FIELD_VISIBILITY = gql`
  query caseIdFieldVisibility {
    visibility: caseIdFieldVisibility {
      mode
      preset
      householdIdEnabled
      householdCodeEnabled
    }
  }
`;

// The selectable format presets, each carrying the reason it cannot currently be chosen (if any),
// so the picker can explain itself rather than just greying an option out.
export const GET_CASE_ID_PRESETS = gql`
  query caseIdPresets {
    presets: caseIdPresets {
      preset
      label
      pattern
      example
      requiresHouseholdId
      requiresHouseholdCode
      blockedReason
    }
  }
`;
